/**
 * Test ID utilities for Button component
 *
 * Pattern: All test IDs are generated via named setter functions.
 * This ensures consistency between components and tests.
 */

import { generateTestId } from "@client-shared";

/**
 * Generate test ID for buttons with text children
 * @param label - Button text content (will be converted to kebab-case)
 * @returns Test ID string
 */
export const setButtonTestId = (label: string): string => generateTestId("Button", label.replace(/\s+/g, "-").toLowerCase());

/**
 * Generate test ID for icon-only buttons (no text children)
 * @param variant - Button variant (default, destructive, outline, etc.)
 * @returns Test ID string
 */
export const setIconButtonTestId = (variant: string = "default"): string => generateTestId("Button", `${variant}-icon`);
